



















import {Component, Vue} from "vue-property-decorator";
import {getPublicPath} from "@/shared/services/helper/utils";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import PLCostSearch from "@/modules/pickinglistcost/components/PickingListCostSearch/index.vue";
import PLCostTable from "@/modules/pickinglistcost/components/PickingListCostTable/index.vue";
import {PickingListCostStore} from "@/modules/pickinglistcost/store";
import {PickingListCostParams} from "@/modules/pickinglistcost/params";
import PLCostDetail from "@/modules/pickinglistcost/components/PickingListCostDetail/index.vue";

@Component({
    name: "PickingListCost",
    components: {PLCostDetail, PLCostTable, PLCostSearch},
})
export default class extends mixins(CommonMixin) {
    visible = false;
    id = null;
    printObj = {
        id: "picking-list-cost-print",
        popTitle: 'Logistic',
        extraCss: `${getPublicPath()}assets/css/print.css`,
    };

    created() {
        PickingListCostStore.updatePickingListCostParams({
            ...new PickingListCostParams(),
        });
        PickingListCostStore.listPickingListCost(PickingListCostStore.params);
    }

    get pickingListCosts() {
        return PickingListCostStore.ids.map((id: number) => PickingListCostStore.data[id]);
    }

    onChangePage(pagination) {
        PickingListCostStore.listPickingListCost({
            ...PickingListCostStore.params,
            page: pagination.current
        })
    }

    async seeDetail(id: number) {
        if (isNaN(id)) return;
        this.id = id as any;
        await PickingListCostStore.listBillLadingInPickingListCost(this.id);
        this.visible = true;
    }

    async deletePickingListCost(id: number) {
        if (isNaN(id)) return;
        try {
            await PickingListCostStore.deletePickingListCost(id);
            this.$message.success("Xóa bảng kê thành công");
        } catch (e) {
            this.$message.error(e?.response?.data?.message || 'Xóa bảng kê thất bại');
        }
    }

    async confirmPickingListCost(id: number) {
        if (isNaN(id)) return;
        try {
            await PickingListCostStore.confirmPickingListCost(id);
            this.$message.success("Xác nhận bảng kê thành công");
        } catch (e) {
            this.$message.error(e?.response?.data?.message || 'Xác nhận bảng kê thất bại');
        }
    }
}
